<template>
  <div class="d-flex flex-column gap-5 align-items-center w-100 p-3">
    <div style="height: 200px; background-color: #056331;" class="mx-5 w-100 d-flex align-items-center justify-content-center rounded-3">
      <h1 class="text-white">{{ $t('beneficios') }}</h1>
    </div>
    <ul class="mx-5 d-flex flex-column gap-4 list-unstyled">
      <li class="item-home">
          <img :src="getFlyer(3)" alt="Menu Semanal" class="img-fluid rounded-4">
      </li>
      <li class="item-home">
        <a href="https://www.clubdebeneficios.com" class="text-decoration-none text-secondary d-flex flex-column gap-4" target="_blank">
          <img :src="getFlyer(1)" alt="Beneficios" class="img-fluid rounded-4">
        </a>
      </li>
      <li class="item-home">
        <a href="https://m365.cloud.microsoft/apps/" class="text-decoration-none text-secondary d-flex flex-column gap-4" target="_blank">
          <img :src="getFlyer(2)" alt="Medien Archiv" class="img-fluid rounded-4">
        </a>
      </li>
      <li class="item-home">
          <img :src="getFlyer(4)" alt="Menu Semanal" class="img-fluid rounded-4 w-100">
      </li>
    </ul>
    <br>
  </div>
</template>

<script lang="ts">
  import { onMounted, ref, computed} from 'vue';
  import { useI18n } from 'vue-i18n';
  // Importamos las imágenes para que Vue las procese correctamente
  import img1Es from '@/assets/Flyer-beneficios-Treffpunkt-1-español.webp';
  import img1De from '@/assets/Flyer-beneficios-Treffpunkt-1-español.webp';
  import img2Es from '@/assets/Flyer-beneficios-Treffpunkt-2-español.webp';
  import img2De from '@/assets/Flyer-beneficios-Treffpunkt-2-español.webp';
  import img3Es from '@/assets/Flyer-beneficios-Treffpunkt-3-español.webp';
  import img3De from '@/assets/Flyer-beneficios-Treffpunkt-3-español.webp';
  import img4Es from '@/assets/Flyer-beneficios-Treffpunkt-4-español.webp';
  import img4De from '@/assets/Flyer-beneficios-Treffpunkt-4-aleman.webp';

export default {
  name: "BeneficiosPage",
  setup() {
    const { t, locale } = useI18n();
    const message = ref('You are not logged in!');
    const imageUrl = ref(''); // For storing the image URL
    //const user = computed(() => store.state.user as Usuario | null);

    // 1. Definimos una interfaz para la estructura de las imágenes
    interface ImageDictionary {
      [key: number]: string; // Esto es el "index signature" que pide el error
    }

    // 2. Definimos la estructura del objeto completo
    const images: Record<string, ImageDictionary> = {
      español: {
        1: img1Es,
        2: img2Es,
        3: img3Es,
        4: img4Es
      },
      aleman: {
        1: img1De,
        2: img2De,
        3: img3De,
        4: img4De
      }
    };

    const langSuffix = computed(() => {
      return locale.value === 'de' ? 'aleman' : 'español';
    });

    // Función segura para obtener la imagen
    const getFlyer = (id: number) => {
      return images[langSuffix.value][id];
    };

    const isTokenValid = () => {
      const token = localStorage.getItem('authToken')
      if (!token) return false;

      try {
        const [, payloadBase64] = token.split('.');
        const payload = JSON.parse(atob(payloadBase64));
        const currentTime = Math.floor(Date.now() / 1000); // Tiempo actual en segundos
        return payload.exp > currentTime; // Comparar el tiempo de expiración
      } catch (error) {
        console.error('Error al decodificar el token:', error);
        return false;
      }
    };

    onMounted(async () => {
      const lastUpdate = localStorage.getItem("lastUpdate");
      const today = new Date().toISOString().split("T")[0]; // Obtiene solo la fecha (YYYY-MM-DD)

      if (lastUpdate !== today) {
        localStorage.setItem("lastUpdate", today);
        window.location.reload(); // Recarga la página solo si no se ha recargado hoy
      }
      if (isTokenValid()) {
        console.log('El token es válido.');
      }
    })
    return {
      message,
      imageUrl,
      t,
      getFlyer
    }
  }
}
</script>
<style scoped>
.qr-image {
  max-width: 99%;  /* Asegura que la imagen no exceda el ancho del contenedor */
  height: auto;     /* Mantiene la proporción de la imagen */
}
.item-docentes{
  max-width: 300px;
}
.item-home{
  width: 800px;
  max-width: 80vw;
}
</style>